import React from 'react'
import EmojiIconDialog from './EmojiIconDialog'
import HowToPlayDialog from './HowToPlayDialog'
import { GameSounds } from 'src/ui/sound/types'

type DashboardDialogsProps = {
  fullScreen: boolean
  showEmojiPreview: boolean
  showHowToPlay: boolean
  selectedPlayer?: { id?: number; name?: string }
  onCloseEmoji: () => void
  onCloseHowToPlay: () => void
  onChangeIcon: (playerId: number | undefined, emoji: string) => void
  sounds?: Pick<GameSounds, 'click' | 'swipe'>
}

const DashboardDialogs: React.FC<DashboardDialogsProps> = ({
  fullScreen,
  showEmojiPreview,
  showHowToPlay,
  selectedPlayer,
  onCloseEmoji,
  onCloseHowToPlay,
  onChangeIcon,
  sounds,
}) => {
  return (
    <>
      <EmojiIconDialog
        fullScreen={fullScreen}
        open={showEmojiPreview}
        selectedPlayer={selectedPlayer}
        onClose={onCloseEmoji}
        onChangeIcon={onChangeIcon}
      />
      <HowToPlayDialog
        open={showHowToPlay}
        fullScreen={fullScreen}
        sounds={sounds}
        onClose={onCloseHowToPlay}
      />
    </>
  )
}

export default DashboardDialogs
